import { NavigateFunction } from 'react-router-dom';

import { makeApiRequest } from '../../lib/http/makeApiRequest';
import { User } from '../../types/user.types';
import { AuthTokens } from './auth.types';

export const completeAuth = async (params: {
  tokens: AuthTokens;
  setUserData: (user: User) => void;
  navigate: NavigateFunction;
}): Promise<void> => {
  const { tokens, setUserData, navigate } = params;

  localStorage.setItem('accessToken', tokens.accessToken);
  localStorage.setItem('refreshToken', tokens.refreshToken);

  const userResponse: User = await makeApiRequest('/v1/user', {
    method: 'GET',
    headers: {
      Authorization: `Bearer ${tokens.accessToken}`,
    },
  });

  setUserData(userResponse);
  navigate('/settings');
  window.close();
};
